import { Accordion,AccordionSummary, AccordionDetails,  Box,
  Card, CardContent, Grid, Tooltip, Typography, TextField,
  IconButton,
  Avatar,
  Divider} 
from "@mui/material";
import Snackbar from './snackbar';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ProfileIcon from '../shared/ProfileIcon';
import ClearIcon from '@mui/icons-material/Clear';
import SendIcon from '@mui/icons-material/Send';
import JoinInnerIcon from '@mui/icons-material/JoinInner';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import LoadingButton from "@mui/lab/LoadingButton";
import "./ephTracker.css";
import React, { useState, useEffect, useContext } from "react";
import api from "../../service/api";
import dcrDetails from "../../config/DcrDetailsConfig.json"
import InboxReferenceLink from '../../config/ProfileDetailsData.json'
import CONFIG from "../../config";
import PopUpMsg from '../../config/popUpMsg.json'
import ConfirmationPopup from "./ConfirmationPopup";
import LaunchIcon from '@mui/icons-material/Launch';
import { DirectionContext } from '../../context/DirectionProvider';
import MergeDetails from "./mergeDetails";
import GroupsIcon from '@mui/icons-material/Groups';
import { Done, ContentCopy } from "@mui/icons-material";
import CONSTANT from '../../Constant/Constant'
 
 const RequestDetails = (props) => {    
   const direction = useContext(DirectionContext);
   const [expanded, setExpanded] = useState(true);
   const [popUpMessages] = useState(PopUpMsg.ephInbox)
   const [details, setDetails] = useState(props.details);
   const [tab, setTab] = useState("1");
   const [comment, setComment] = useState("");
   const [open, setOpen] = useState(false);
   const [message, setMessage] = useState({'type': '', 'message':''});
   const [disable, setDisable] = useState(false);
   const [approvePending, setApprovePending] = useState(false);
   const [rejectPending, setRejectPending] = useState(false);
   const [showConfirmationPopup, setShowConfirmationPopup] = useState(false)
   const [dcrAction, setDcrAction] = useState('')
   const [popUpMessage, setpopUpMessage]  = useState({})
   const [isCopied, setIsCopied] = useState(null)


   useEffect(()=>{
       setDetails(props.details)
       setComment('')
   },[props.details])

    const getZipValue = (zip) => {
      // handle is Zip value is {value: ''}, null, undefined or empty object
        if (zip === undefined || zip === null || (typeof zip === 'object' && Object.keys(zip).length === 0) || (zip.value !== undefined && zip.value === '')) {
            return '';
        }
        let zip4 = zip.Zip4;
        let zip5 = zip.Zip5;
        let editZip = zip.value;
        if (editZip) {
            return editZip;
        }
        else if (!zip4 && !zip5) {
            return zip;
        }
        else if (zip4 === undefined) {
            return zip5[0].value;
        } else if (zip5 === undefined) {
            return zip4[0].value;
        } else {
            return zip5[0].value + '-' + zip4[0].value;
        }
    }

 const handleTabChange=(event, newValue) => {
   setTab(newValue);
 };

 const extractValues = (input) => {
    console.log("Input to extractValues:", input);
        // Normalize input to array
        const arr = Array.isArray(input) ? input : [input];

        // Extract the "value" field safely
        const result = arr
            .map(item => item?.value)
            .filter(v => v); // Remove null/undefined

        return result.join(', ');
    }

 const handleHCORelations=()=>{  
   return dcrDetails.relations.map((item, index) => (
     <div
       className="_wg-dynamic-text"
       style={{ marginLeft: "10px",marginRight: "10px", fontSize: "small", marginBottom: "1px" }}
     >
       {details.UpdatedValues?.Relations[0][item.key] &&
         item.key != "Address" && (
           <>
             <strong dir={direction}>{item.label}:&nbsp;</strong>
             <span className="_wg-exclude">{details.UpdatedValues?.Relations[0][item.key]["value"]}</span>
           </>
         )}
       {details.UpdatedValues?.Relations[0][item.key] &&
         item.key == "Address" &&
         <>
          <strong dir={direction}>{item.label}:&nbsp;</strong>
          {
          details.UpdatedValues?.Relations[0][item.key].map((res, key) => {
            return (
              <Accordion
                expanded={expanded[`${key}-${index}`] || false}
                key={key}
                style={{
                  backgroundColor: "#f8f9f9",
                  marginTop: 3
                }}
              >
                <AccordionSummary
                  style={{ fontSize: "small" }}
                  onClick={handleSpecialtyAccordion(`${key}-${index}`)}
                  expandIcon={                   
                      <ExpandMoreIcon />                
                  }
                >
                  {`Address ${key + 1}`}
                </AccordionSummary>
                <AccordionDetails
                  className=""
                  style={{ fontSize: "small", backgroundColor: "#ffffff" }}
                >
                  {Object.values(dcrDetails.Address).map((value) => {
                    return (
                      <>
                        {value.key && res[value.key] && (
                          <>
                            <span dir={direction} className="text-muted" style={{ fontSize: "small" }}>
                              {value.label}:{" "}
                            </span>
                            <span className="_wg-exclude">
                              {value.key === 'zip' 
                                ? res[value.key]?.["value"] || res[value.key]?.["Zip5"]?.[0]?.['value'] 
                                : res[value.key]?.["value"]}
                            </span>
                            <br />
                          </>
                        )}
                      </>
                    );
                  })}
                  {/* BRICK details for this address (if present) */}
                  {(res.BRICK || res.Brick || res.brick) && (
                    <div style={{ marginTop: 6 }}>
                      <strong className='pb-1 pt-1 _wg-dynamic-text' style={{ fontSize: 'small', display: 'flex', marginBottom: '4px' }}>{dcrDetails.BRICK?.label || 'BRICK'}:</strong>
                      {Object.keys(dcrDetails.BRICK || {}).filter(k => k !== 'label').map((brickKey, bi) => {
                        const cfg = dcrDetails.BRICK[brickKey];
                        const valueKey = cfg?.key || brickKey;
                        const brickSource = res.BRICK || res.Brick || res.brick;
                        const fieldNames = [valueKey, 'Brick' + valueKey, brickKey, 'Brick' + brickKey];
                        let rawVal;
                        for (const fieldName of fieldNames) {
                          if (brickSource?.[fieldName]) {
                            rawVal = brickSource[fieldName];
                            break;
                          }
                        }
                        if (!rawVal) return null;
                        if (rawVal && rawVal.hasOwnProperty('Old') && rawVal.hasOwnProperty('New')) {
                          return (
                            <div key={bi} style={{ fontSize: 'small' }}>
                              {cfg?.label || brickKey}:&nbsp;{rawVal['Old']['value']}
                              &nbsp;<ArrowRightAltIcon style={{ fill: 'grey' }} />&nbsp;{rawVal['New']['value']}
                            </div>
                          );
                        }
                        return (
                          <div key={bi}>
                            <span className='text-muted'>{cfg?.label || brickKey}: </span>
                            <span className=" _wg-exclude">{Array.isArray(rawVal) ? extractValues(rawVal) : (rawVal?.value ?? rawVal)}</span>
                            <br />
                          </div>
                        );
                      })}
                    </div>
                  )}
                </AccordionDetails>
              </Accordion>
            )
          })
          }
         </>
        }

     </div>
   ));
 }

 const handleRelations=()=>{
  let data = [];
  data['Effective end date']= details?.UpdatedValues?.Relations[0] && details?.UpdatedValues?.Relations[0]['EffectiveEndDate'] ? details?.UpdatedValues?.Relations[0]['EffectiveEndDate']['value'] :'';
  data['Effective start date']= details?.UpdatedValues?.Relations[0] && details?.UpdatedValues?.Relations[0]['EffectiveStartDate'] ? details?.UpdatedValues?.Relations[0]['EffectiveStartDate']['value'] :''
  data['Active flag']= details?.UpdatedValues?.Relations[0]['ActiveFlag'] ? details.UpdatedValues.Relations[0]['ActiveFlag']['value']:'';
  data['Rank']=details?.UpdatedValues?.Relations[0]['Rank'] ? details.UpdatedValues.Relations[0]['Rank']['value'] : '';
  data['Relationship type code']=details?.UpdatedValues?.Relations[0]['RelationTypeCode'];

  return (
    <Accordion
      expanded={expanded[details.Id+`relationships`] || false}
      key={Math.random()}
      style={{
        backgroundColor: "#f8f9f9",
        marginTop: 3,
        marginRight: 8,
        marginLeft: 8,

      }}
    >
      <AccordionSummary
        style={{ fontSize: "small" }}
        onClick={handleSpecialtyAccordion(details.Id+`relationships`)}
        expandIcon={<ExpandMoreIcon />}
      >
        {details.UpdatedValues.Relations[0].RelationTypeCode ? details.UpdatedValues.Relations[0].RelationTypeCode : 'CUSTOMER-CONTACT AFFILIATION'}
      </AccordionSummary>
      <AccordionDetails
        className="_wg-dynamic-text"
        style={{ fontSize: "small", backgroundColor: "#ffffff" }}
      >

        {dcrDetails.relationship.map((item) => (
          <>          
          <span dir={direction} className='text-muted'>{item.label}: </span>
          <span className="_wg-exclude">{data[item.label] ? data[item.label] : item.value } </span><br/>  
          </>
        ))}
      </AccordionDetails>
    </Accordion>
  );   
 }

 const handleRelationsDeactivation=()=>{
  let data =  details.UpdatedValues.Relations.filter((res)=> res.IsStatusChanged != undefined)  
  return(
    <>
    {
      data.length>0&&
      data.map((res)=>{
        return(
          <Accordion
        expanded={expanded[details.Uri+`relationships`] || false}
        key={Math.random()}
        style={{
          backgroundColor: "#f8f9f9",
          marginTop: 3,
          marginRight: 8,
          marginLeft: 8,
  
        }}
      >
        <AccordionSummary
          style={{ fontSize: "small" }}
          onClick={handleSpecialtyAccordion(details.Uri+`relationships`)}
          expandIcon={<ExpandMoreIcon />}
        >
          {handleAccordionLable(res, details?.UpdatedValues?.Entity?.Type )}
        </AccordionSummary>
        <AccordionDetails
          className="_wg-dynamic-text"
          style={{ fontSize: "small", backgroundColor: "#ffffff" }}
        >     
            <>          
            <span dir={direction} className='text-muted'>Active Flag: </span>
            <span className="_wg-exclude">{res.ActiveFlag ? `${res?.ActiveFlag?.Old?.value} `+String.fromCharCode(10142)+` ${res?.ActiveFlag?.New?.value}` : '' } </span><br/> 
            <span dir={direction} className='text-muted'>Relation Type: </span>
            <span className="_wg-exclude">{res?.RelationType ? res?.RelationType : '' } </span><br/>  
            </>
          
        </AccordionDetails>
      </Accordion>
        )
      })
    }
    </>
  )   
 }

 const handleSpecialtyAccordion = (key) => () => {
   setExpanded((prevExpanded) => ({
     ...prevExpanded,
     [key]: !prevExpanded[key],
   }));
 };

 const handleAccordian = (key)=> (event, isExpanded) =>{
  setExpanded({
    ...expanded,
    [key]: isExpanded,
  });
 }

 const handleCommentChange=(event)=>{
   setComment(event.target.value);
 }

 const handleAccordionLable = (response, entity)=>{
  if(entity ==="HCP" && response?.RelationType == 'HCPtoHCO'){
    return response.endObject.label
  }else if(entity ==="HCO"){   
    if(response?.RelationType == 'HCPtoHCO'){
      return response?.Type == 'HCPtoHCO' ?  response?.startObject?.label : (response?.Type == 'DepttoDept' ? response.endObject.label : response.startObject.label)
    }else if(response?.RelationType == 'HCOtoHCO'){
      return response.endObject.label
    }    
  }
 }

 const formatText = (inputText)  => {
  return inputText
      ?.replace(/_/g, ' ')  // Replace underscores with spaces
      ?.replace(/\b\w/g, (char) => char.toUpperCase())  // Capitalize the first letter of each word
      + ' User'; // Add 'User' at the end
}

 const handleComment=(value)=>{
   if(value.length > 0) {
     setDetails({...details, 
       "ReviewerComments":value
     });
   }
   else{
     setComment("");
   }
 }

 const handleCloseMessage=(event,reason)=>{
   if (reason === 'clickaway') {
     return;
   }
   setOpen(false);
   setDisable(false);//to allow other dcr's
 }

 async function approveDcr(){
   (await api
     .dcrApprove({"dcrId":details.Id,"reviewerComments":details.ReviewerComments, 'requestType': props.selectedTab})
     .then((response) => {
       setOpen(true);
       setMessage({'type':'success','message':popUpMessages[0].dcrAction.approved.replace(/{{DCR}}/g, props.selectedTab == 'DCR' ? 'DCR' : 'Merge request')});
       setDisable(true);
       setApprovePending(false);
       details.DcrStatus="Approved";
       props.refreshTab()
       setShowConfirmationPopup(false)
     })
     .catch((error) => {
       setOpen(true);
       setMessage({'type':'error', 'message':popUpMessages[0].dcrAction.approveFailed.replace(/{{DCR}}/g, props.selectedTab == 'DCR' ? 'DCR' : 'Merge request')});
       setApprovePending(false);
       setDisable(false);
       setShowConfirmationPopup(false)
     }))
  }

 async function rejectDcr(){
   (await api
     .dcrReject({"dcrId":details.Id,"reviewerComments":details.ReviewerComments, 'requestType': props.selectedTab})
     .then((response) => {
       setOpen(true);
       setMessage({'type':'success','message':popUpMessages[0].dcrAction.rejected.replace(/{{DCR}}/g, props.selectedTab == 'DCR' ? 'DCR' : 'Merge request')});
       setDisable(true);
       setRejectPending(false);
       details.DcrStatus="Rejected";
       props.refreshTab()
       setShowConfirmationPopup(false)
     })
     .catch((error) => {
       setOpen(true);
       setMessage({'type':'error', 'message': popUpMessages[0].dcrAction.rejectedFailed.replace(/{{DCR}}/g, props.selectedTab == 'DCR' ? 'DCR' : 'Merge request')});
       setRejectPending(false);
       setDisable(false);
       setShowConfirmationPopup(false)
     }))
   }

  const handleApprove = ()=>{
    setApprovePending(true);
    if(details?.UpdatedValues?.Entity?.NoActiveAddress || details?.UpdatedValues?.Entity?.NoActiveRelation){
      api.dcrApprove({"dcrId":details.Id, 'requestType': props.selectedTab, "validateDCR":true}).then((response) => {
        let resp = response.data.Data;
        if(resp.Address.Error && resp.Relations.Error){          
          setpopUpMessage({title:'Confirmation', 
            message: popUpMessages[0].dcrAction.ephAddressAndRelationValidation})
          setShowConfirmationPopup(true)
          setApprovePending(false);
          setDcrAction('approve')
        }else if(resp.Address.Error || resp.Relations.Error){          
          setpopUpMessage({title:'Confirmation', 
            message: resp.Address.Error ? 
            popUpMessages[0].dcrAction.ephAddressValidation : 
            popUpMessages[0].dcrAction.ephRelationValidation})
          setShowConfirmationPopup(true)
          setApprovePending(false);
          setDcrAction('approve')
        }else{
          setpopUpMessage({title:'Confirmation', message: popUpMessages[0].dcrAction.approvedWarning.replace(/{{DCR}}/g, props.selectedTab == 'DCR' ? 'DCR' : 'Merge request')})
          setShowConfirmationPopup(true)
          setDcrAction('approve')
          setApprovePending(false);
        }
      }).catch((error) => {        
        setOpen(true);
        setMessage({'type':'error', 'message':popUpMessages[0].dcrAction.approveFailed.replace(/{{DCR}}/g, props.selectedTab == 'DCR' ? 'DCR' : 'Merge request')});
        setApprovePending(false);
        setDisable(false);
      })

    }else {
      setpopUpMessage({title:'Confirmation', message: popUpMessages[0].dcrAction.approvedWarning.replace(/{{DCR}}/g, props.selectedTab == 'DCR' ? 'DCR' : 'Merge request')})
      setShowConfirmationPopup(true)
      setDcrAction('approve')
      setApprovePending(false);
    }
  }
  
  const handleReject = () =>{
    setpopUpMessage({title:'Confirmation', message: popUpMessages[0].dcrAction.rejectionWarning.replace(/{{DCR}}/g, props.selectedTab == 'DCR' ? 'DCR' : 'Merge request')})
    setShowConfirmationPopup(true)
    setDcrAction('reject')
  }

  const closePopup = () =>{
    setShowConfirmationPopup(false)
    setOpen(true);
    setMessage({'type':'error', 'message': popUpMessages[0].dcrAction.resetComment.replace(/{{DCR}}/g, props.selectedTab == 'DCR' ? 'DCR' : 'Merge request')});
    setComment('');
    setDetails({...details, ReviewerComments: ''});
    setApprovePending(false);
    setDisable(false);
  }

 const parseJSON = (data) => {
   if (Array.isArray(data)) {
     return data.map(item =>( 
       <div key={item.value} >
       {parseJSON(item)}
     </div>
     ));
   } else if (typeof data === 'object' && data !== null) {
     return Object.keys(data).map(key => (
       key!=="Address"&&key!=="Specialities"&&key!=="NewIdentifiers"&&key!=="Email"&&key!=="Phone"&& key!=="OriginalSource"&&key!=="BRICK"&&key!=="BrickType"&&key!=="BrickId"&&key!=="BrickEffectiveStartDate"&&key!=="BrickEffectiveEndDate"&&key!=="BrickSource"&&key!=="IsNew" ?
       <div key={key} style={{ display: 'flex',marginBottom: '1px', marginTop:0 }}>
         {key!=="value"&&key!=="Old"&&key!=="lookupRawValue"&&key!=="Type"&&key!=="Specialities"&&key!=="NewIdentifiers"&&key!=="Email"&&key!=="Phone"&&key!=="OriginalSource"&&key!=="BRICK"&&key!=="BrickType"&&key!=="BrickId"&&key!=="BrickEffectiveStartDate"&&key!=="BrickEffectiveEndDate"&&key!=="BrickSource"&&key!=="IsNew"?(key!=="New"?<strong className="_wg-dynamic-text" style={{ fontSize:'small', display:'flex',marginBottom:'1px',marginLeft:'10px', marginTop: 3}}>{dcrDetails[key]?.label?dcrDetails[key].label:key}:&nbsp;</strong>:
         <div style={{ fontSize:'small'}}>&nbsp;<ArrowRightAltIcon sx={{fill:'grey', marginTop:0, transform:direction==='rtl'?'rotate(180deg)':''}}/>&nbsp;</div>):key==="lookupRawValue"?<span style={{display:'flex', color:'grey', fontSize:'small'}}>&nbsp;|&nbsp;</span>:''} 
         {/* {parseJSON(data[key])} */}
         {Array.isArray(data[key]) ? data[key].map((subItem, subIndex) => (
         <div style={{display:'flex', marginTop:3}} key={subIndex} >
           {parseJSON(subItem)}
         </div>)) : key!=="Type"? parseJSON(data[key]):''}
       </div>
       :
       <div key={key}>
       {key === "Specialities" ||key==="NewIdentifiers"||key==="BRICK"?
       <>
             <strong className="pb-2 pt-1 _wg-dynamic-text" style={{fontSize:'13px', display:'flex',marginLeft:'10px'}}>{dcrDetails[key]?.label?dcrDetails[key].label:key}:&nbsp;</strong>             
             {data[key].map((item,index)=>
               <Accordion className="mb-2 p-0" key={`${key}-${index}`} expanded={expanded[`${key}-${index}`] || false} style={{backgroundColor:'#f8f9f9', marginTop:3, marginLeft: 8, marginRight: 8}} >
                 <AccordionSummary style={{fontSize:'small'}}
                     onClick={handleSpecialtyAccordion(`${key}-${index}`)}
                     expandIcon={<ExpandMoreIcon />}>
                       {key==="Specialities"?item?.Specialty:(item?.Type[0]?.value ? item?.Type[0]?.value : item?.Type?.value )}
                     
                 </AccordionSummary>
                 <AccordionDetails style={{fontSize:'small', backgroundColor:'#ffffff'}} className="_wg-dynamic-text">
                   {key==="Specialities"?
                   <React.Fragment>
                    {item?.SpecialtyType &&
                    <>
                    <span dir ={direction} className='text-muted'>Type: </span>
                    <span className=" _wg-exclude">{item?.SpecialtyType}</span><br/>
                    </>
                    }
                    {item?.Rank && !item?.isDeleted &&
                    <>
                    <span dir ={direction} className='text-muted'>Rank: </span>
                    <span className=" _wg-exclude">{item?.Rank}</span><br/>
                    </>
                    }
                    {item?.EffectiveStartDate &&
                    <>
                    <span dir ={direction} className='text-muted'>Effective Start Date: </span>
                    <span className=" _wg-exclude">{item?.EffectiveStartDate}</span><br/>
                    </>
                    }
                    {item?.EffectiveEndDate &&
                    <>
                    <span dir ={direction} className='text-muted'>Effective End Date: </span>
                    <span className=" _wg-exclude">{item?.EffectiveEndDate}</span><br/>
                    </>
                    }
                    {item?.isDeleted &&
                    <>
                    <span dir ={direction} className='text-muted'>Deactivated: </span>
                    <span className=" _wg-exclude">{item?.isDeleted ? 'Yes' : ''}</span><br/>
                    </>
                    }
                   </React.Fragment>:
                   key==="BRICK"?
                   <React.Fragment>
                    {Object.keys(dcrDetails.BRICK || {}).filter(k => k !== 'label').map((brickKey) => {
                      const cfg = dcrDetails.BRICK[brickKey];
                      const valueKey = cfg?.key || brickKey;
                      const fieldNames = [valueKey, 'Brick' + valueKey, brickKey, 'Brick' + brickKey];
                      let rawVal;
                      for (const fieldName of fieldNames) {
                        if (item?.[fieldName]) {
                          rawVal = item[fieldName];
                          break;
                        }
                      }
                      if (!rawVal) return null;
                      if (rawVal && rawVal.hasOwnProperty('Old') && rawVal.hasOwnProperty('New')) {
                        return (
                          <div key={brickKey}>
                            <span className='text-muted'>{cfg?.label || brickKey}: </span>
                            <span className=" _wg-exclude">{rawVal['Old']['value']}</span>
                            &nbsp;<ArrowRightAltIcon style={{fill:'grey', fontSize: 'small'}} />&nbsp;
                            <span className=" _wg-exclude">{rawVal['New']['value']}</span><br/>
                          </div>
                        );
                      }
                      return (
                        <div key={brickKey}>
                          <span className='text-muted'>{cfg?.label || brickKey}: </span>
                          <span className=" _wg-exclude">{Array.isArray(rawVal) ? extractValues(rawVal) : (rawVal?.value ?? rawVal)}</span><br/>
                        </div>
                      );
                    })}
                   </React.Fragment>:
                   <React.Fragment>
                    <span  dir ={direction}className='text-muted _wg-dynamic-text'>ID: </span>
                    <span className=" _wg-exclude">{Array.isArray(item?.ID) && item?.ID[0]?.value ? item?.ID[0]?.value : item?.ID?.value}</span><br/>
                    <span  dir ={direction} className='text-muted _wg-dynamic-text'>Status: </span>
                    <span className="_wg-exclude">
                      {item?.Status?.Old && item?.Status?.New
                        ? `${item?.Status?.Old.value} `+ String.fromCharCode(10142)+` ${item?.Status?.New.value}`
                        : Array.isArray(item?.Status) && item?.Status[0]?.value
                        ? item?.Status[0]?.value
                        : item?.Status?.value
                        ? item?.Status?.value
                        : item?.Status[0]?.value
                        ? item?.Status[0]?.value
                        : ""}
                    </span><br/>

                    <span  dir ={direction} className='text-muted _wg-dynamic-text'>Sub Type: </span>
                    <span className=" _wg-exclude">{Array.isArray(item?.SubType) && item?.SubType[0]?.value ? item?.SubType[0]?.value : item?.SubType?.value}</span><br/>
                    <span  dir ={direction} className='text-muted _wg-dynamic-text'>Effective Start Date: </span>
                    <span className=" _wg-exclude">{Array.isArray(item?.EffectiveStartDate) && item?.EffectiveStartDate[0]?.value ? item?.EffectiveStartDate[0]?.value : item?.EffectiveStartDate?.value}</span><br/>
                    <span dir ={direction} className='text-muted _wg-dynamic-text'>Effective End Date: </span>
                    <span className="_wg-exclude">
                    {item?.EffectiveEndDate?.Old && item?.EffectiveEndDate?.New 
                        ? `${item?.EffectiveEndDate?.Old?.value} ` + String.fromCharCode(10142) + ` ${item?.EffectiveEndDate?.New?.value}`
                        : (Array.isArray(item?.EffectiveEndDate) && item?.EffectiveEndDate[0]?.value)
                        ? item?.EffectiveEndDate[0]?.value 
                        : item?.EffectiveEndDate?.value 
                        ? item?.EffectiveEndDate?.value 
                        : ""}
                    </span><br/>

                   </React.Fragment>
                   }
                   </AccordionDetails>
               </Accordion>
             )}
             </>:
             <>
             {key==="Address"&&(
               <>
               <strong className="pb-2 pt-1 _wg-dynamic-text" style={{ fontSize:'small', display:'flex',marginBottom:'1px',marginLeft:'10px'}}>{dcrDetails[key]?.label?dcrDetails[key].label:key}:</strong>
               {data[key].map((address,index)=>
               <Accordion className='p-0' key={`${key}-${index}`} expanded={expanded[`${key}-${index}`] || false} style={{backgroundColor:'#f8f9f9', marginTop:5, marginLeft: 8, marginRight: 8}}>
               <AccordionSummary style={{fontSize:'small'}}
                   onClick={handleSpecialtyAccordion(`${key}-${index}`)}
                   expandIcon={<ExpandMoreIcon />}>
                     {key==="Address"?<span>Address {index+1}</span>:''}
               </AccordionSummary>
               <AccordionDetails style={{fontSize:'small', backgroundColor:'#ffffff'}}>
                 {
                 Object.values(dcrDetails.Address).map((res, loc)=>{
                  return(
                    res != 'Address' && address[res.key] &&
                    (address[res.key].hasOwnProperty('Old') && address[res.key].hasOwnProperty('New')?
                    <div key={loc} style={{ fontSize:'small'}}>{res.label ? res.label :key}:&nbsp;
                        {address[res.key]['Old']['value']}
                        &nbsp;<ArrowRightAltIcon style={{fill:'grey'}}/>&nbsp;
                        {address[res.key]['New']['value']}
                    </div>
                  :<><span key={loc} className='text-muted'>{res.label}: </span>
                    {address[res.key] ? res?.key === 'Zip' ? getZipValue(address[res.key]) : extractValues(address[res.key]): ''}<br/></>                    ))
                  })
                }
                {
                  // Render BRICK details if present on the address (entity address block)
                  (() => {
                    return (address?.BRICK || address?.Brick || address?.brick) && (
                      <div style={{ marginTop: 12, paddingTop: 8, borderTop: '1px solid #e0e0e0' }}>
                        <strong className='pb-1 pt-1 _wg-dynamic-text' style={{ fontSize: 'small', display: 'block', marginBottom: '8px' }}>BRICK:</strong>
                        {Object.keys(dcrDetails.BRICK || {}).filter(k => k !== 'label').map((brickKey, bi) => {
                          const cfg = dcrDetails.BRICK[brickKey];
                          const valueKey = cfg?.key || brickKey;
                          const brickArr = address?.BRICK || address?.Brick || address?.brick;
                          const brickObj = Array.isArray(brickArr) ? brickArr[0] : brickArr;
                          const fieldNames = [valueKey, 'Brick' + valueKey, brickKey, 'Brick' + brickKey];
                          let rawVal;
                          for (const fieldName of fieldNames) {
                            if (brickObj?.[fieldName]) {
                              rawVal = brickObj[fieldName];
                              break;
                            }
                          }
                          if (!rawVal) return null;
                          if (rawVal && rawVal.hasOwnProperty('Old') && rawVal.hasOwnProperty('New')) {
                            return (
                              <div key={bi} style={{ fontSize: 'small', marginBottom: '4px' }}>
                                <span className='text-muted'>{cfg?.label || brickKey}: </span>
                                <span className=" _wg-exclude">{rawVal['Old']['value']}</span>
                                &nbsp;<ArrowRightAltIcon style={{ fill: 'grey', fontSize: 'small' }} />&nbsp;
                                <span className=" _wg-exclude">{rawVal['New']['value']}</span>
                              </div>
                            );
                          }
                          return (
                            <div key={bi} style={{ fontSize: 'small', marginBottom: '4px' }}>
                              <span className='text-muted'>{cfg?.label || brickKey}: </span>
                              <span className=" _wg-exclude">{Array.isArray(rawVal) ? extractValues(rawVal) : (rawVal?.value ?? rawVal)}</span>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })()
                }
                 </AccordionDetails>
               </Accordion>
               )}
               </>
             )}
             </>
           }
       </div>
     ));
   } else if (typeof data === 'object' && data !== null && (Object.keys(data).some(k => ['BrickType', 'BrickId', 'BrickEffectiveStartDate', 'BrickEffectiveEndDate', 'BrickSource'].includes(k)))) {
     return (
       <div style={{ marginTop: 12, paddingTop: 8, borderTop: '1px solid #e0e0e0' }}>
         <strong className='pb-1 pt-1 _wg-dynamic-text' style={{ fontSize: 'small', display: 'block', marginBottom: '8px' }}>BRICK:</strong>
         {['BrickType', 'BrickId', 'BrickEffectiveStartDate', 'BrickEffectiveEndDate', 'BrickSource'].map((brickKey, bi) => {
           const cfg = dcrDetails[brickKey];
           if (!cfg || !data[brickKey]) return null;
           const rawVal = data[brickKey];
           if (rawVal && rawVal.hasOwnProperty('Old') && rawVal.hasOwnProperty('New')) {
             return (
               <div key={bi} style={{ fontSize: 'small', marginBottom: '4px' }}>
                 <span className='text-muted'>{cfg?.label || brickKey}: </span>
                 <span className=" _wg-exclude">{rawVal['Old']['value']}</span>
                 &nbsp;<ArrowRightAltIcon style={{ fill: 'grey', fontSize: 'small' }} />&nbsp;
                 <span className=" _wg-exclude">{rawVal['New']['value']}</span>
               </div>
             );
           }
           return (
             <div key={bi} style={{ fontSize: 'small', marginBottom: '4px' }}>
               <span className='text-muted'>{cfg?.label || brickKey}: </span>
               <span className=" _wg-exclude">{Array.isArray(rawVal) ? extractValues(rawVal) : (rawVal?.value ?? rawVal)}</span>
             </div>
           );
         })}
       </div>
     );
   } else 
       return <span style={{fontSize:'small'}}>{data}</span>;
 };

 const renderDcrDetails=(data)=>{
    const allKeys = Object.keys(dcrDetails)
    const keys=Object.keys(data)
    let showKeys = [];
    allKeys.map((key)=> {
      if(keys.includes(key))
      {
        showKeys.push(key)
      }
    })   
   const change=[];
   const add=[];
   const del=[]
   showKeys.map(key =>
    dcrDetails.hasOwnProperty(key) ? 
    key === "Address" ? (
      data[key].map(address =>
        address.hasOwnProperty('AddressID') || address.hasOwnProperty('IsStatusChanged') ? change.push({[key]: address}) : (address.hasOwnProperty('IsNew') || details?.IsStandaloneHco  ? add.push({[key]: address}): change.push({[key]: address}))
      )
    ) :
    key === "NewIdentifiers" ? (
      data[key].map(identifier =>
        identifier.hasOwnProperty('Deactivated') ? change.push({[key]: identifier}) : add.push({[key]: identifier})
      )
    )    
    : (Array.isArray(data[key]) ?
      data[key].map(item =>
        item.hasOwnProperty('isDeleted') ? del.push({[key]: item}) : 
        (item.hasOwnProperty('Old') && item.hasOwnProperty('New') ? change.push({[key]: item}) : add.push({[key]: item}))
      ) :
      (data[key].hasOwnProperty('isDeleted') ? del.push({[key]: data[key]}) : 
      (data[key].hasOwnProperty('Old') && data[key].hasOwnProperty('New') ? change.push({[key]: data[key]}) : add.push({[key]: data[key]})))
    ) :
    ''
  );  
   let changeValues = {};
   change.forEach(item => {
     let changeKey = Object.keys(item)[0];
   if (!changeValues[changeKey]) {
     changeValues[changeKey] = [];
   }
   changeValues[changeKey].push(item[changeKey]);
   })
 let changeArray = Object.keys(changeValues).map(key => {
   if (!['Type', 'Uri', 'Label'].includes(key)) {
     return { [key]: changeValues[key] };
   }
   return null;
 }).filter(item => item !== null);

 let addValues = {};
   add.forEach(item => {
     let addKey = Object.keys(item)[0];
   if (!addValues[addKey]) {
     addValues[addKey] = [];
   }
   addValues[addKey].push(item[addKey]);
   })
 let addArray = Object.keys(addValues).map(key => {
   if (!['Type', 'Uri', 'Label'].includes(key)) {
     return { [key]: addValues[key] };
   }
   return null;
 }).filter(item => item !== null);

 let delValues = {};
   del.forEach(item => {
     let delKey = Object.keys(item)[0];
   if (!delValues[delKey]) {
    delValues[delKey] = [];
   }
   delValues[delKey].push(item[delKey]);
   })
 let delArray = Object.keys(delValues).map(key => {
   if (!['Type', 'Uri', 'Label'].includes(key)) {
     return { [key]: delValues[key] };
   }
   return null;
 }).filter(item => item !== null);

     return( 
       <div>  
        {/* {
          <div style={{backgroundColor:'#e6f2ff3d'}} className="pb-3"> 
           <strong dir={direction} style={{fontSize:'small',  marginLeft: "10px",marginRight: "10px", marginBottom: "1px", paddingTop:"10px"}}>Country Code:&nbsp;</strong>
         </div>

        } */}

         {add.length>0?
         <React.Fragment>
         <div style={{backgroundColor:'#e6f2ff3d'}} className="pt-1 pb-3" key={Math.random()}>
         <Typography sx={{ margin: '10px',marginRight:'10px', marginBottom:'-05px', paddingTop: 1, paddingBottom: 1}}  className="mt-1 _wg-dynamic-text"> Additions:</Typography>
            {parseJSON(addArray)}
         </div>
         <br/></React.Fragment>:''}

         {change.length>0?
         <div>
         <div style={{backgroundColor:'#e6f2ff3d'}} className="pb-3 mt-1"  key={Math.random()}> 
           <Typography sx={{ margin: '10px',marginRight:'10px', marginBottom:'-05px', paddingTop: 1, paddingBottom: 1}}  className="mt-1 _wg-dynamic-text"> Changes:</Typography>
            {parseJSON(changeArray)}
         </div>
         <br/></div>:''}

         {del.length>0?
         <React.Fragment>
         <div style={{backgroundColor:'#e6f2ff3d'}} className="pt-1 pb-3"  key={Math.random()}>
         <Typography sx={{ margin: '10px',marginRight:'10px', marginBottom:'-05px', paddingTop: 1, paddingBottom: 1}}  className="mt-1 _wg-dynamic-text"> Deletions:</Typography>
            {parseJSON(delArray)}
         </div>
         <br/></React.Fragment>:''}
       </div>
     )
 }

 const handleLaunch = (event, link) => {
  event?.stopPropagation()
  window.open(link)
 }

 const handleCopyClipboard = (event, data) => {
  event.stopPropagation();
  navigator.clipboard.writeText(data)
  setIsCopied(data)
  setTimeout(() => setIsCopied(null), 1000);
 }

   return ( 
     <>
      <Card sx={{ overflowY: 'auto', overflowX: ' hidden', height: '100%' }}>
     <CardContent style={{padding:'0px'}}>
       <Grid  style={{backgroundColor:"#e6f2ff", border:"1px solid #e6f2ff", textAlign:'center', paddingTop:3}}>

       {/* <div style={{display:'flex', alignItems:'center'}}>
       </div> */}
        <ClearIcon style={{padding: 2, cursor:'pointer', float:'left'}} onClick={()=>props.closeDetails()}/>
        <span style={{marginLeft:'-30px'}} className="_wg-dynamic-text">
         <b>
         {details.RequestType == 'DCR' ? 'Data Change Request' : details.RequestType + ' Request' }
         </b>
       </span> 
       </Grid>

       <TabContext value={tab}>
       <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor:'#e6f2ff', display:'flex', justifyContent:'space-around'}}>
           <TabList onChange={handleTabChange}>
             <Tab className='_wg-dynamic-text' label="Information" value="1" />
             <Tab className='_wg-dynamic-text' label="Comments" value="2" />
           </TabList>
           </Box>

      {props.selectedTab == 'DCR' &&
       <TabPanel value="1" style={{padding:'0px'}}>        
         {
           details.UpdatedValues && details.UpdatedValues.Entity&&details.UpdatedValues.Entity.Type==="HCP" &&
       <>
       <Accordion expanded={expanded[details.Id] || false} className="m-2" key={Math.random()} onChange={handleAccordian(details.Id)}>
         <AccordionSummary
           expandIcon={ <Tooltip disableFocusListener title={expanded[details.Id]  ? "Close" : "Open"}>
             <ExpandMoreIcon />
             </Tooltip>}>
              <ProfileIcon
               type={'HCP'}
               sx={{width: '35px', height: '35px'}}
           />
            <h6 style={{marginBlock: 'auto', paddingLeft:'10px', paddingRight: '10px'}}>
            {details?.UpdatedValues?.Entity?.IsNew || !details?.UpdatedValues?.Entity?.Uri ? 'New HCP' : (details?.UpdatedValues?.Entity?.Label ? details?.UpdatedValues?.Entity?.Label : (details?.UpdatedValues?.Entity?.FirstName && details?.UpdatedValues?.Entity?.LastName ? <>{details?.UpdatedValues?.Entity?.FirstName.value} {details?.UpdatedValues?.Entity?.LastName.value} </> : 'Existing HCP'  ) ) }
            <br/> {details?.UpdatedValues?.Entity?.Uri ? (<span className="text-muted" style={{fontSize:'small'}}>HCP &nbsp;</span>):''}          
            {details.HcpUniqueId && details.HcpEntityId &&
              <>
              <span className="text-muted" style={{fontSize:'small'}}>({details.HcpUniqueId})</span>
              <Tooltip title={isCopied && isCopied === details.HcpUniqueId ? "Copied!" : "Click to Copy"}>
                 <IconButton size="small" aria-label="copy" color="primary" onClick={(e)=> handleCopyClipboard(e, details.HcpUniqueId)}>
                   {isCopied && isCopied === details.HcpUniqueId ? <Done fontSize="10px"/> : <ContentCopy fontSize={'10px'}/>}
                 </IconButton>
               </Tooltip>
              <Tooltip disableFocusListener title={"View in EPH"}>
                <IconButton size="small" aria-label="link " color="primary" onClick={(e)=> handleLaunch(e, InboxReferenceLink.INBOX_REFERENCE_LINK[0][CONFIG.env]+details.HcpEntityId)}>
                  <LaunchIcon fontSize={'10px'}/>
                </IconButton>
             </Tooltip>
              </>
            }
            </h6>             
            </AccordionSummary>
           <AccordionDetails className="p-0">
             {
             details.UpdatedValues.Entity&&
             details.UpdatedValues.Entity.Type==="HCP"&&
                renderDcrDetails(details.UpdatedValues.Entity)
                }
           </AccordionDetails>
       </Accordion>
       </>
       }
       {
         details?.UpdatedValues && details?.UpdatedValues?.Entity&&details?.UpdatedValues?.Entity?.Type==="HCO" &&
       <Accordion expanded={expanded[details.Id+'new-hco'] || false} className="m-2" key={Math.random()} onChange={handleAccordian(details.Id+'new-hco')}>
         <AccordionSummary
           expandIcon={ <Tooltip disableFocusListener title={expanded[details.Id+'new-hco']  ? "Close" : "Open"}>
             <ExpandMoreIcon />
             </Tooltip>}>
           <ProfileIcon
               type={'HCO'}
               sx={{width: '35px', height: '35px'}}
           />
         <h6 style={{marginBlock:'auto', paddingLeft: '10px',paddingRight: '10px'}}>
         {details?.UpdatedValues?.Entity?.IsNew || !details?.UpdatedValues?.Entity?.Uri ? 'New HCO' : (details?.UpdatedValues?.Entity?.Label ? details?.UpdatedValues?.Entity?.Label : 'Existing HCO')}
         <br/>{details?.UpdatedValues?.Entity && details?.UpdatedValues?.Entity?.Uri ? (<span className="text-muted" style={{fontSize:'small'}}>HCO ({details?.UpdatedValues?.Entity?.Uri})  </span>):''}
         {details.IsStandaloneHco ? ((details?.StandaloneHcoUniqueId || details?.HcoUniqueId) && (details?.StandaloneHcoUniqueId || details?.HcoUniqueId)?.length !== 0 &&
              <>

              <span className="text-muted" style={{fontSize:'small'}}>{Array.isArray(details?.StandaloneHcoUniqueId || details?.HcoUniqueId) && (details?.StandaloneHcoUniqueId || details?.HcoUniqueId)[0] ? ((details?.StandaloneHcoUniqueId || details?.HcoUniqueId)[0].length > 0 ? `(${(details?.StandaloneHcoUniqueId || details?.HcoUniqueId)[0]})` : '') : ((details?.StandaloneHcoUniqueId || details?.HcoUniqueId).length > 0 ? `(${details?.StandaloneHcoUniqueId || details?.HcoUniqueId})` : '') }</span>
              <Tooltip title={isCopied && isCopied === (details?.StandaloneHcoUniqueId || details?.HcoUniqueId) ? "Copied!" : "Click to Copy"}>
                 <IconButton size="small" aria-label="copy" color="primary" onClick={(e)=> handleCopyClipboard(e, details?.StandaloneHcoUniqueId || details?.HcoUniqueId)}>
                   {isCopied && isCopied === (details?.StandaloneHcoUniqueId || details?.HcoUniqueId) ? <Done fontSize="10px"/> : <ContentCopy fontSize={'10px'}/>}
                 </IconButton>
               </Tooltip>
              {(details?.StandaloneHcoEntityId || details?.HcoEntityId) &&
                            <Tooltip disableFocusListener title={"View in EPH"}>
              <IconButton size="small" aria-label="link " color="primary" onClick={()=> window.open(InboxReferenceLink.INBOX_REFERENCE_LINK[0][CONFIG.env]+(details?.StandaloneHcoEntityId || details?.HcoEntityId))}>
                <LaunchIcon fontSize={'10px'}/>
              </IconButton>
              </Tooltip>}
              </>) :
              (((details?.HcoUniqueId && details?.HcoUniqueId?.length !== 0) || details?.HcoEntityId || details?.UpdatedValues?.Entity?.Uri) &&
                <>
                {details?.HcoUniqueId && details?.HcoUniqueId?.length !== 0 &&
                <>
                <span className="text-muted" style={{fontSize:'small'}}>{Array.isArray(details?.HcoUniqueId) && details?.HcoUniqueId[0] ? (details?.HcoUniqueId[0].length > 0 ? `(${details?.HcoUniqueId[0]})` : '') : (details.HcoUniqueId.length > 0 ? `(${details.HcoUniqueId})` : '') }</span>
                <Tooltip title={isCopied && isCopied === details.HcoUniqueId ? "Copied!" : "Click to Copy"}>
                 <IconButton size="small" aria-label="copy" color="primary" onClick={(e)=> handleCopyClipboard(e, details.HcoUniqueId)}>
                   {isCopied && isCopied === details.HcoUniqueId ? <Done fontSize="10px"/> : <ContentCopy fontSize={'10px'}/>}
                 </IconButton>
               </Tooltip>
                </>
                }
                {(details?.HcoEntityId || details?.UpdatedValues?.Entity?.Uri) &&
                <Tooltip disableFocusListener title={"View in EPH"}>
                <IconButton size="small" aria-label="link " color="primary" onClick={()=> window.open(InboxReferenceLink.INBOX_REFERENCE_LINK[0][CONFIG.env]+(details?.HcoEntityId || details?.UpdatedValues?.Entity?.Uri))}>
                  <LaunchIcon fontSize={'10px'}/>
                </IconButton>
                </Tooltip>
                }
                </>)
          }
         </h6>
         </AccordionSummary>
           <AccordionDetails className="p-0">
             {
                 details.UpdatedValues.Entity&&details.UpdatedValues.Entity.Type==="HCO"&&
                renderDcrDetails(details.UpdatedValues.Entity) 
             }
           </AccordionDetails>
       </Accordion>
       }

       {
       (details?.UpdatedValues?.Relations && details?.UpdatedValues?.Relations?.length>0 && ((details?.UpdatedValues?.Relations[0]?.Label || details?.UpdatedValues?.Relations[0]?.Name) && details.IsNewHco || details.UpdatedValues.IsRelationInDcr && details.UpdatedValues.IsAddressInDcr))?
       <Accordion expanded={expanded[details.Id+'newhco'] || false} className="m-2"  key={Math.random()} onChange={handleAccordian(details.Id+'newhco')}>
         <AccordionSummary
           expandIcon={ <Tooltip disableFocusListener title={expanded[details.Id+'newhco']  ? "Close" : "Open"}>
             <ExpandMoreIcon />
             </Tooltip>}>
             <ProfileIcon
               type={'HCO'}
               sx={{width: '35px', height: '35px'}}
           />
           <h6 style={{marginBlock:'auto', paddingLeft: '10px', paddingRight: '10px'}}>
           {details?.UpdatedValues?.Relations[0]?.IsNew || !details?.UpdatedValues?.Relations[0]?.Uri ? 'New HCO' : (details?.UpdatedValues?.Relations[0]?.Label || details?.UpdatedValues?.Relations[0]?.Name?.value || 'Existing HCO')}
           <br/>{details?.UpdatedValues?.Relations[0]?.Uri && details?.UpdatedValues?.Relations[0]?.Label ? (<span className="text-muted" style={{fontSize:'small'}}>HCO ({details?.UpdatedValues?.Relations[0]?.Uri})</span>):''}
           {details?.HcoUniqueId && details?.HcoUniqueId[0] && details?.RelationsId &&
              <>
              <span className="text-muted" style={{fontSize:'small'}}>({details.HcoUniqueId[0]})</span>
              <Tooltip title={isCopied && isCopied === details.HcoUniqueId[0] ? "Copied!" : "Click to Copy"}>
                 <IconButton size="small" aria-label="copy" color="primary" onClick={(e)=> handleCopyClipboard(e, details.HcoUniqueId[0])}>
                   {isCopied && isCopied === details.HcoUniqueId[0] ? <Done fontSize="10px"/> : <ContentCopy fontSize={'10px'}/>}
                 </IconButton>
               </Tooltip>
              {details?.RelationsId &&
              <Tooltip disableFocusListener title={"View in EPH"}>
                <IconButton size="small" aria-label="link " color="primary" onClick={(e)=> handleLaunch(e, InboxReferenceLink.INBOX_REFERENCE_LINK[0][CONFIG.env]+details?.RelationsId)}>
                  <LaunchIcon fontSize={'10px'}/>
                </IconButton>
              </Tooltip>}
              </>
            }
           </h6>
          
         </AccordionSummary>
         <AccordionDetails className="p-0" style={{backgroundColor:'#e6f2ff3d'}}>
         <Typography sx={{marginBottom:'0px', marginRight:'10px',  margin:'10px', paddingTop: 2, paddingBottom: 0}}  className="mt-1 _wg-dynamic-text"> Additions:</Typography> 
           <div className="pl-1 pb-3 pr-1"> {handleHCORelations()} </div>
         </AccordionDetails>
       </Accordion>
       :""
       }

      {
       (details?.UpdatedValues?.Relations && details?.UpdatedValues?.Relations?.length>0)?
       <Accordion expanded={expanded[details.Id+'relationship'] || false} key={Math.random()}  className="m-2" onChange={handleAccordian(details.Id+'relationship')}>
         <AccordionSummary
           expandIcon={ <Tooltip disableFocusListener title={expanded[details.Id+'relationship'] ? "Close" : "Open"}>
             <ExpandMoreIcon />
             </Tooltip>}>
              <JoinInnerIcon
               type={'Relationship'}
               sx={{width: '35px', height: '35px', margin: 0, fill:'grey'}}
           />
           <h6 className="_wg-dynamic-text" style={{marginBlock: 'auto', paddingLeft:'10px', paddingRight:'10px'}}>Relationships</h6>
         </AccordionSummary>
         <AccordionDetails className="p-0" style={{backgroundColor:'#e6f2ff3d'}}>
            <div className="_wg-dynamic-text" style={{ marginLeft: "10px",marginRight: "10px",  fontSize: "small", marginBottom: "1px", paddingTop:"10px" }}>
              {(details.UpdatedValues.Relations[0].Label || details.UpdatedValues.Relations[0].Name)&& 
              <>
              <Typography sx={{ marginBottom:'-05px', paddingTop: 1, paddingBottom: 2}}  className="mt-1 _wg-dynamic-text"> Additions:</Typography>
              <strong className="_wg-dynamic-text" dir={direction} style={{fontSize:'small'}}>{details.UpdatedValues.Relations[0].RelationType}:&nbsp;</strong>
              <span className="_wg-exclude">{details.UpdatedValues.Relations[0].Label ? details.UpdatedValues.Relations[0].Label : details.UpdatedValues.Relations[0].Name.value} </span>            
              {details.HcoUniqueId && details.RelationsId &&
              <>                
                <span className="text-muted" style={{fontSize:'small'}}>({details.HcoUniqueId[0]})</span>
                <Tooltip title={isCopied && isCopied === details.HcoUniqueId[0] ? "Copied!" : "Click to Copy"}>
                 <IconButton size="small" aria-label="copy" color="primary" onClick={(e)=> handleCopyClipboard(e, details.HcoUniqueId[0])}>
                   {isCopied && isCopied === details.HcoUniqueId[0] ? <Done fontSize="10px"/> : <ContentCopy fontSize={'10px'}/>}
                 </IconButton>
               </Tooltip>
                <Tooltip disableFocusListener title={"View in EPH"}>
                  <IconButton size="small" aria-label="link " color="primary" onClick={(e)=> handleLaunch(e, InboxReferenceLink.INBOX_REFERENCE_LINK[0][CONFIG.env]+details.RelationsId)}>
                    <LaunchIcon fontSize={'10px'}/>
                  </IconButton>
                </Tooltip>
              </>
              }
              <br />
              </>
              }
             </div>
            {details?.UpdatedValues?.Relations?.filter((res)=> res.IsNew !== undefined).length > 0 && 
              <>
              <strong  dir={direction} style={{fontSize:'small', marginLeft: "10px", marginBottom: "1px", paddingTop:"10px"}}>Active Flag:&nbsp;</strong>Y<br />              
              <strong dir={direction} style={{fontSize:'small',  marginLeft: "10px",marginRight: "10px", marginBottom: "1px", paddingTop:"10px"}}>Affiliation classification:&nbsp;</strong>
              <div className="pl-1 pt-1 pb-3 pr-1"> {handleRelations()} </div>
              </>
            }

            {details?.UpdatedValues?.Relations?.filter((res)=> res.IsStatusChanged != undefined).length > 0 && 
            <div className="pt-1 pb-3">
              <Typography sx={{ margin: '10px',marginRight:'10px', marginBottom:'-05px', paddingTop: 1, paddingBottom: 2}}  className="mt-1 _wg-dynamic-text"> Changes:</Typography>
                {handleRelationsDeactivation()}
            </div>
            }
        </AccordionDetails>
       </Accordion>
       :""
       }

       </TabPanel> 
      } 
      {props.selectedTab == 'Merge' && 
       <TabPanel value = '1' hidden={props.selectedTab != 'Merge'} style={{padding:'0px'}}>
       <Accordion expanded={expanded[details.Id+'winner'] || false} className="m-2" key={Math.random()} onChange={handleAccordian(details.Id+'winner')}>
         <AccordionSummary
           expandIcon={ <Tooltip disableFocusListener title={expanded[details.Id+'winner']  ? "Close" : "Open"}>
             <ExpandMoreIcon />
             </Tooltip>}>
            <Avatar>
             <img src='/user.png' alt='Footer logo' className='p-1' width={'60px'} height={'40px'}/>           
             </Avatar>
            <h6 style={{marginBlock: 'auto', paddingLeft:'10px', paddingRight: '10px'}}>
            Winner Profile          
            </h6>             
            </AccordionSummary>
           <AccordionDetails className="p-0">
           <div style={{backgroundColor:'#e6f2ff3d'}} className="p-3"> 
              <MergeDetails details={details.winner} />
            </div>
           </AccordionDetails>
       </Accordion>

       <Accordion expanded={expanded[details.Id+'loser'] || false} className="m-2" key={Math.random()} onChange={handleAccordian(details.Id+'loser')}>
         <AccordionSummary
           expandIcon={ <Tooltip disableFocusListener title={expanded[details.Id+'loser']  ? "Close" : "Open"}>
             <ExpandMoreIcon />
             </Tooltip>}>
             <Avatar>
              {
                details?.losers && details?.losers?.length > 1 ?
              <GroupsIcon               
                    sx={{ width: '30px', height: '30px', color: "#ffffff" }}
                  /> :
                  <ProfileIcon
                    sx={{ width: '35px', height: '35px' }}
           />
              }
           </Avatar>
                    <h6 style={{ marginBlock: 'auto', paddingLeft: '10px', paddingRight: '10px' }}>
                      {`Loser Profile${details?.losers && details?.losers?.length > 1 ? "s" : ""}`}
            </h6>             
            </AccordionSummary>
           <AccordionDetails className="p-0">
                    <div style={{ backgroundColor: '#e6f2ff3d' }} className="p-3">
              <MergeDetails details={details.losers} />
            </div>
           </AccordionDetails>
       </Accordion>
        
       </TabPanel>
      }
       <TabPanel value="2">
        <Typography sx={{color:`${details?.CrmDcrId ? '#009edb': '#ce2a1d'}`, fontSize:"16px"}}>
            <Divider textAlign="center">Created on {details?.CrmDcrId ? 'CRM': 'ECS'}</Divider>
        </Typography>
        <Typography className="_wg-dynamic-text">
           <span dir={direction} className="text-muted fw-bold" style={{fontSize:'small'}}>Requested On: </span>
            <span className="_wg-exclude" style={{fontSize:'small'}}>{new Date(details.CreatedDate).toLocaleDateString("en-US", { year: 'numeric', month: 'short', day: 'numeric' })+" "+new Date(details.CreatedDate).toTimeString().split(' ')[0]+" (UTC)" || 'N/A'}</span>
       </Typography>
       <Typography className="_wg-dynamic-text">
           <span dir={direction} className="text-muted fw-bold" style={{fontSize:'small'}}>Requestor Name: </span>
           <span className="_wg-exclude" style={{fontSize:'small'}}>{details?.RequestorName ? details?.RequestorName?.includes(" - Network") ? details?.RequestorName.split(" - Network")[0].trim() + ` (${details.CreatedBy})` : details.RequestorName + ` (${details.CreatedBy})` : details.CreatedBy || `N/A`} </span>
       </Typography>
       <Typography className="_wg-dynamic-text">
           <span dir={direction} className="text-muted fw-bold" style={{fontSize:'small'}}>Requestor Email: </span>
           <span className="_wg-exclude" style={{wordBreak:'break-all', fontSize:'small'}}>{details.RequestorEmail || 'N/A'}</span>
       </Typography>
       <Typography className="_wg-dynamic-text">
           <span dir={direction} className="text-muted fw-bold" style={{fontSize:'small'}}>Requestor Comments: </span>
           <span className="_wg-exclude" style={{wordBreak:'break-all', fontSize:'small'}}>{details?.DcrComments?.split('|| Requester Email:')[0]}</span>
       </Typography>         
       {
        details?.ReviewerComments && details?.ReviewerComments.length > 0 && comment &&
          <Typography className="_wg-dynamic-text">
              <span dir={direction} className="text-muted fw-bold" style={{fontSize:'small'}}>Reviewer Comments: </span>
              <span className="_wg-exclude" style={{wordBreak:'break-all', fontSize:'small'}}>{details?.ReviewerComments}</span>
          </Typography>         
       }   

         {/* Reviewer details */}
         { details?.DcrStatus && CONSTANT.DCR_ACTIONED_STATE.includes(details.DcrStatus) && details?.ReviewerEmail !== '' &&
                 <>
                   <Typography className="_wg-dynamic-text" sx={{ padding: '20px 0px 0px 0px' }}>
                     <span dir={direction} className="text-muted fw-bold" style={{ fontSize: 'small' }}>Reviewed On: </span>
                     <span className="_wg-exclude" style={{ fontSize: 'small' }}>{new Date(details.UpdatedDate).toLocaleDateString("en-US", { year: 'numeric', month: 'short', day: 'numeric' }) + " " + new Date(details.UpdatedDate).toTimeString().split(' ')[0] + " (UTC)" || 'N/A'}</span>
                   </Typography>
                   <Typography className="_wg-dynamic-text">
                     <span dir={direction} className="text-muted fw-bold" style={{ fontSize: 'small' }}>Reviewed By: </span>
                     <span className="_wg-exclude" style={{ fontSize: 'small' }}>{details?.ReviewerName?.includes(" - Network") ? details?.ReviewerName?.split(" - Network")[0].trim() + ` (${details.UpdatedBy})` : details.ReviewerName ? details.ReviewerName + ` (${details.UpdatedBy})` : details.UpdatedBy || `N/A`} </span>
                   </Typography>
                   <Typography className="_wg-dynamic-text">
                     <span dir={direction} className="text-muted fw-bold" style={{ fontSize: 'small' }}>Reviewer Email: </span>
                     <span className="_wg-exclude" style={{ wordBreak: 'break-all', fontSize: 'small' }}>{details.ReviewerEmail || 'N/A'}</span>
                   </Typography>
                   <Typography className="_wg-dynamic-text">
                     <span dir={direction} className="text-muted fw-bold " style={{ fontSize: 'small' }}>Reviewer Comments: </span>
                     <span className="_wg-exclude" style={{ wordBreak: 'break-all', fontSize: 'small' }}>{details?.ReviewerComments}</span>
                   </Typography>
                 </>
        }
         <br/><br/>
         {(details.DcrStatus=== 'Pending' ||details.DcrStatus=== 'Requested') && details?.ReviewerComments?.length===0 && details.AssignedToId===props.userId&&
         <div>
         <div style={{display:'flex'}}>
           <TextField fullWidth variant="outlined"
              size="small" 
              placeholder ="Type a comment..." 
              className="_wg-dynamic-text"
              disabled={details.AssignedToId!==props.userId?true:false}
              value={details.ReviewerComments ? details.ReviewerComments : comment} 
              onChange={handleCommentChange}
              />
           <SendIcon style={{cursor:'pointer', margin:'6px'}} onClick={()=>handleComment(comment)}/>
         </div>
         </div>
         }
       
       </TabPanel>
       </TabContext>
       {
       (details.DcrStatus=== 'Pending' ||details.DcrStatus=== 'Requested') && details.AssignedToId===props.userId?
         <div style={{display:'flex',justifyContent:'flex-end', padding:'15px'}}>
       <LoadingButton style={{color:'white',backgroundColor:disable?'lightgrey':'#d32f2f',borderColor:disable?'lightgrey':'#d32f2f', width:'35%'}}
         loading={approvePending}
         loadingPosition="end"
         endIcon={
           <ArrowForwardIosIcon style={{ fontSize: "medium" , transform:direction==='rtl'?'rotate(180deg)':''}} />
         }
         className="_wg-dynamic-text"
         variant="outlined"
         onClick={handleApprove}
         disabled={disable}
       >
       Approve
     </LoadingButton>
     &emsp;
     <LoadingButton
         loading={rejectPending}
         loadingPosition="end"
         endIcon={
           <ArrowForwardIosIcon style={{ fontSize: "medium" , transform:direction==='rtl'?'rotate(180deg)':''}} />
         }
         className="_wg-dynamic-text"
         variant="outlined"
         style={{color:disable?'grey':'black', border:disable?'1px solid lightgrey':'1px solid black',backgroundColor:disable?'lightgrey':'',width:'35%'}}
         onClick={handleReject}
         disabled={disable}
       >
       Reject
     </LoadingButton>

     </div>
     :''}
     </CardContent>
   </Card>  
   {open&&(
   <Snackbar
   openSnackBar={open}
   handleCloseSnackBar={handleCloseMessage}
   message={message}
   position={{ vertical:'bottom', horizontal:'right' }}
 />)}

  {showConfirmationPopup &&
    <ConfirmationPopup
    handleApprove = {()=> approveDcr()}
    handleReject = {()=> rejectDcr()}
    dcrAction = {dcrAction}
    currentTab = {props.selectedTab}
    closePopup = {()=>closePopup()}
    popUpMessage = {popUpMessage}
    />
  }   
 </>             
  
      
   );
 };
 
 export default RequestDetails;